import React from 'react';

const HelpSupport: React.FC = () => (
  <div className="max-w-3xl mx-auto py-16 px-4">
    <h1 className="text-5xl font-extrabold mb-6 bg-gradient-to-r from-blue-600 via-purple-500 to-pink-500 bg-clip-text text-transparent drop-shadow-lg flex items-center gap-3">
      <span>🆘</span> Help & Support
    </h1>
    <div className="bg-white/80 rounded-2xl shadow-xl p-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-blue-700 flex items-center gap-2"><span>🚀</span> Quick Start</h2>
      <ol className="list-decimal list-inside mb-2 text-gray-700 text-lg">
        <li>Create a free account or log in.</li>
        <li>Choose your native language and start learning English.</li>
        <li>Practice grammar, sentences, and vocabulary using smart cards.</li>
        <li>Track your progress and celebrate achievements!</li>
      </ol>
    </div>
    <div className="border-l-4 border-pink-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-pink-700 flex items-center gap-2"><span>❓</span> Frequently Asked Questions</h2>
      <ul className="list-disc list-inside mb-2 text-gray-700 text-lg">
        <li><b>How do I change my learning language?</b> Go to your profile/settings and select your preferred language.</li>
        <li><b>How do I mark an item as completed?</b> Click the “Done” button on any card.</li>
        <li><b>How do I add items to Favorites or Memorize?</b> Use the “Favorite” or “Memorize” buttons on each card.</li>
        <li><b>Is my progress saved?</b> Yes! Your progress is saved to your account and synced across devices.</li>
      </ul>
    </div>
    <div className="border-l-4 border-yellow-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-yellow-700 flex items-center gap-2"><span>🛠️</span> Troubleshooting</h2>
      <ul className="list-disc list-inside mb-2 text-gray-700 text-lg">
        <li>If you’re having trouble logging in, try resetting your password or clearing your browser cache.</li>
        <li>For display issues, refresh the page or try a different browser.</li>
        <li>If progress isn’t updating, check your internet connection and try again.</li>
      </ul>
    </div>
    <div className="border-l-4 border-blue-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-blue-700 flex items-center gap-2"><span>📧</span> Contact Us</h2>
      <p className="mb-2 text-gray-700 text-lg">Need more help? Email us at <a href="mailto:learn.with.me.beginning@gmail.com" className="text-blue-600 underline font-bold">learn.with.me.beginning@gmail.com</a> and we’ll get back to you as soon as possible.</p>
    </div>
    <div className="mt-10 text-center">
      <span className="inline-block text-xl font-semibold text-blue-600 bg-blue-100 rounded-full px-6 py-2 shadow">We’re here to help you succeed! 💪</span>
    </div>
  </div>
);

export default HelpSupport; 